export default {
  // Generic actions
  actions: {
    cancel: "Cancel",
    close: "Close",
    save: "Save",
    apply: "Apply",
    confirm: "Confirm",
    delete: "Delete",
    refresh: "Refresh",
  },

  // Generic messages
  messages: {
    loading: "Loading...",
    loading_info: "Loading information...",
    saving: "Saving changes...",
    deleting: "Deleting...",
    noData: "No data available",
    error: "An error occurred",
  },

  // Common button patterns
  buttons: {
    clearAll: "Clear all",
    selectAll: "Select all",
    deselectAll: "Deselect all",
  },

  titles: {
    sample_info: "Sample Information: {barcode}",
  },

  //
  // Sample Info Dialog
  //
  sample_info: {
    tabs: {
      basic_info: "Basic Information",
      instruments: "Instruments",
      results_sets: "Results Sets",
    },

    results_sets_table: {
      group_name: "Set",
    },
  },
};
